import { mergeMap } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import * as NavActions from '../../../store/returns/nav/returns.nav.actions';
import * as Actions from './returns.selected-returns.actions';

export const returnsChangeView = (action$) =>
  action$.pipe(
    ofType(NavActions.RETURNS_CHANGE_VIEW),
    mergeMap(() => {
      return of(Actions.setSelectedReturns([]));
    }),
  );
